import { makeAutoObservable, runInAction } from 'mobx';
import { IApiKey } from '../../../../models/IntegrationsTypes';
import ReturngoApiService from '../../../../services/api/returngo-api-service';
import { rootContainer, TYPE } from '../../../../services/container/root';
import { ISaveable, WithOld } from '../../../../stores/types';

class ApiKeyEditorStore implements ISaveable {
    public get model(): IApiKey {
        return this._model;
    }
    private _changes: IApiKey = {} as IApiKey;
    private _isSaving: boolean = false;

    constructor(private _model: IApiKey) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    /********* ISaveable implementation *************/
    public isSaving(): boolean { return this._isSaving; }

    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): IApiKey {
        const data = { ...this._model, ...this._changes };
        return data;
    }

    async save(): Promise<void> {
        const data: WithOld<IApiKey> = this.getUpdatedModel();
        data.__old = this._model;
        this._isSaving = true;
        const integrationConnection = await this.service.updateApiKey(this._model.integrations_connection_id, data);

        runInAction(() => {
            this._changes = {} as IApiKey;
            this._model = integrationConnection.api_key as IApiKey;
            this._isSaving = false;
        });

    }

    private get service(): ReturngoApiService {
        return rootContainer.get<ReturngoApiService>(TYPE.ReturngoApiService);
    }

    public get id(): number {
        return this._model.id;
    }

    public get integrations_connection_id(): number {
        return this._model.integrations_connection_id;
    }

    public get name(): string {
        return this._changes?.name ?? this._model?.name;
    }

    public get created_at(): string {
        return this._model.created_at;
    }

    public get api_key(): string {
        return this._model.api_key;
    }

    public setName(value: string) {
        this._changes.name = value;
    }
}

export default ApiKeyEditorStore;
